import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ScoredRow from './scored/Row'
import ScoredSizeFinder from './scored/SizeFinder'
import TimedRow from './timed/Row'
import TimedSizeFinder from './timed/SizeFinder'
import oget from 'oget'

export default class LeaderboardGroup extends Component {
  static propTypes = {
    i: PropTypes.number.isRequired,
    t: PropTypes.func.isRequired,
    group: PropTypes.array.isRequired,
    roundState: PropTypes.any,
    athletesById: PropTypes.object.isRequired,
    roundConfig: PropTypes.object.isRequired,
    colors: PropTypes.object.isRequired,
    listWidth: PropTypes.number.isRequired,
    roundType: PropTypes.any,
    deviceType: PropTypes.string.isRequired,
    onRowRef: PropTypes.func.isRequired
  }

  render () {
    const {
      i,
      t,
      group,
      colors,
      athletesById,
      columns,
      listWidth,
      tableWidth,
      roundActive,
      roundConfig: {
        cut,
        testData,
        labelsCount,
        ...roundConfig
      },
      roundType,
      deviceType,
      onRowRef
    } = this.props

    const isScored = roundType !== 'Time'

    const SizeFinder = isScored
      ? ScoredSizeFinder
      : TimedSizeFinder

    const Row = isScored
      ? ScoredRow
      : TimedRow
    let trickLabel = null
    // eslint-disable-next-line
    group.map((rowData) => {
      const athlete = athletesById[rowData.externalAthleteId] || {}
      const tricksObj = oget( athlete, 'details.Tricks', {} )
      if (tricksObj.label) {
        trickLabel = tricksObj.label
      }
    })

    return (
      <div className="group">
        <SizeFinder
          i={i}
          className="cell-scores-holder"
          testData={testData}
          columns={columns}
          labelsCount={labelsCount}
          roundConfig={roundConfig}
          listWidth={listWidth}
          tableWidth={tableWidth}
          deviceType={deviceType}
        >
          {({
              className,
              noStyle,
              nameStyle,
              scoreStyle
            }) => (
            group
              .filter(
                (item) => {
                  return typeof item.rank !== 'undefined'
                }
              )
              .map((rowData, rowNumber) => {
                const athlete = athletesById[
                  rowData.externalAthleteId
                  ] || {}

                const style = {
                  ...(rowNumber % 2 === 0
                      ? colors.itemOdd
                      : colors.itemEven
                  ),
                  ...(athlete.isLive
                      ? colors.itemActive
                      : {}
                  ),
                  ...(athlete.isNext && roundActive
                      ? colors.itemNext
                      : {}
                  ),
                  ...(cut === 0 || isNaN(cut) || rowNumber < cut)
                    ? {}
                    : { opacity: .7 }
                }

                return (
                  <div key={`leaderboard_row_${i}_${rowNumber}`}>
                    {cut !== 0 && rowNumber === cut &&
                    <div className="separator"/>
                    }

                    <Row
                      t={t}
                      groupNumber={i}
                      rowNumber={rowNumber}
                      className={className}
                      style={style}
                      noStyle={noStyle}
                      nameStyle={nameStyle}
                      scoreStyle={scoreStyle}
                      colors={colors}
                      athlete={athlete}
                      trickLabel={trickLabel}
                      data={rowData}
                      columns={columns}
                      roundConfig={roundConfig}
                      onRowRef={onRowRef}
                    />
                  </div>
                )
              })
          )}
        </SizeFinder>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/table/TableLeaderboard/Group.js